import Button from "components/ui/Button/Button";
import "features/view/components/Filters/FilterControls.scss";
import { useView } from "features/view/context/ViewContext";

function FilterControls() {
  const { setShowMobileFilters } = useView();
  return (
    <div className="filter-controls">
      <Button onClick={ () => setShowMobileFilters(true) } variant="secondary" className="button--full-width">
        Filter uw resultaten
      </Button>
    </div>
  );
}

export default FilterControls;
